import { Form, Image, Input, message, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Loader from "../../customJS/Loader";
import { getBase64, handleonlyNumber } from "../../customJS/custom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useLocation, useNavigate } from "react-router-dom";
import { getHospitalById, updateHospitalData } from "../../api/Hospital";
import * as configuration from "../../config/app-config.js";
import noLogo from "../../images/noImage.svg";
import { signin } from "../../api/Login.js";
import useAuthService from "../../session/useAuthService.js";

const ViewHospitalProfile = () => {
  const [form] = Form.useForm();
  const [loader, setLoader] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [hospitalData, setHospitalData] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const hospitalId = location.state?.hospitalId;

    // if (!hospitalId) {
    //   navigate(-1);
    // }

    if (hospitalId) {
      getHospitalData({ id: hospitalId });
      setIsEdit(true);
    }
  }, []);

  // const handleSubmit = (values) => {
  //   console.log("Success:", values);
  // };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
    },
  };

  const getHospitalData = (obj) => {
    setLoader(true);
    getHospitalById(obj)
      .then((response) => {
        if (response.data.status === 1) {
          console.log("Success:", response.data.data);
          const data = response.data.data;
          form.setFieldsValue({
            hospitalName: data.hospitalName,
            mailId: data.mailId,
            phoneNo: data.phoneNo,
            website: data.website,
            hospitalAddress: data.hospitalAddress,
            zipCode: data.zipCode,
          });

          if (data.hospitalLogo) {
            // If there is an existing image, set it in the fileList and preview
            const existingFile = {
              uid: "-1", // Unique identifier for the file
              name: data.hospitalLogo,
              status: "done", // Set the status to 'done'
              url: `${configuration.API_URL}auth/assets/${data.hospitalLogo}`,
            };
            setFileList([existingFile]);
            setPreviewImage(existingFile.url);
          }

          setHospitalData(data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const handleSubmit = (values) => {
    const formData = new FormData();
    console.log("values ", fileList);

    formData.append("address", values.hospitalAddress?.trim() || "");
    formData.append("mailId", values.mailId.trim());
    formData.append("hospitalName", values.hospitalName.trim());
    formData.append("website", values.website?.trim() || "");
    formData.append("phoneNo", values.phoneNo?.trim() || "" );
    // formData.append("zipCode", values.zipCode?.trim() || null);
    if (values.zipCode?.trim()) {
      formData.append("zipCode", values.zipCode.trim());
    }

    formData.append("userType", useAuthService.getUserType());
    formData.append("url", configuration.changePasswordUrl);

    if (fileList[0]?.originFileObj) {
      formData.append("hospitalLogo", fileList[0].originFileObj);
    }

    console.log();

    // if (values.upload && values.upload[0]?.originFileObj) {
    //   formData.append("hospitalLogo", values.upload[0].originFileObj);
    // }

    if (isEdit) {
      formData.append("hospitalId", hospitalData.hospitalId);
      formData.append("userId", hospitalData.userId);
      updateHospitalDataAPI(formData);
    } else {
      sendSignInData(formData);
    }

    // if (imageFileList[0]?.originFileObj) {
    //   formData.append("hospitalImage", imageFileList[0].originFileObj);
    // }

    // console.log("formDatahospitalData", hospitalData, formData);
  };

  const updateHospitalDataAPI = (obj) => {
    setLoader(true);
    updateHospitalData(obj).then((response) => {
      if (response.data.status === 1) {
        messageApi.open({
          type: "success",
          content: "Updated Successfully",
          duration: 2,
        });
        setLoader(false);
        // Delay navigation by 2 seconds (2000 milliseconds)
        setTimeout(() => {
          navigate(-1); // or navigate('/some-path') if you're redirecting to a specific route
        }, 2000);
      } else {
        messageApi.open({
          type: "error",
          content: "Something went wrong",
          duration: 2,
        });
        setLoader(false);
      }
    });
  };

  const sendSignInData = (obj) => {
    setLoader(true);
    signin(obj)
      .then((response) => {
        if (response.data.status === 1) {
          form.resetFields();
          // setImageFileList([]);
          setFileList([]);
          messageApi.open({
            type: "success",
            content:
              "The new provider has been created successfully, and an email will be sent to the provider’s office email address.",
            duration: 2,
          });
          setLoader(false);
        } else if (response.data.status === 0) {
          messageApi.open({
            type: "error",
            content: response.data.message,
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        } else if (response.data.status === -1) {
          messageApi.open({
            type: "error",
            content: response.data.message,
            duration: 1,
            className: "ant-alert",
          });
          console.log(
            "Your account has been deleted. Please contact the administrator for help"
          );
          setLoader(false);
        } else {
          messageApi.open({
            type: "error",
            content: "Please try with valid credentials.",
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        messageApi.open({
          type: "error",
          content: "Network error, Please try again later.",
          duration: 1,
          className: "ant-alert",
        });
        setLoader(false);
      });
  };

  return (
    <>
      {loader && <Loader />}
      {contextHolder}
      <>
        <Row className="m-0 px-lg-5 row">
          <Col>
            <h2 className="m-4 uniteColor font-weight700">
              {isEdit ? "Edit" : "Add"} Provider
            </h2>
          </Col>
          <Col className="d-flex justify-content-end align-items-center">
            <Button className="uniteButton" onClick={() => navigate(-1)}>
              <Icon icon="famicons:arrow-back" />
              Back
            </Button>
          </Col>
        </Row>
        <Form
          // disabled={isEdit}
          form={form}
          layout="vertical"
          name="hospitalForm"
          onFinish={handleSubmit}
          validateMessages={validateMessages}
        >
          <Row className="m-0 px-lg-5">
            <Col md="6" xs="12">
              <Form.Item
                // disabled={isEdit}
                label="Provider Name"
                name="hospitalName"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Provider Name" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                // disabled={isEdit}
                label="Provider’s office email"
                name="mailId"
                rules={[
                  { required: true },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input disabled={isEdit} placeholder="Enter Email" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                // disabled={isEdit}
                label="Contact"
                name="phoneNo"
                rules={[
                  { required: false },
                  {
                    pattern: /^\d+$/,
                    message: "Contact number must contain only numbers!",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Contact"
                  onKeyPress={handleonlyNumber}
                />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Website"
                name="website"
                rules={[{ required: false }]}
              >
                <Input placeholder="Enter Website" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Provider Address"
                name="hospitalAddress"
                rules={[{ required: false }]}
              >
                <Input.TextArea rows={3} placeholder="Enter Provider Address" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              <Form.Item
                label="Zip Code"
                name="zipCode"
                rules={[{ required: false }]}
              >
                <Input placeholder="Enter Zip Code" />
              </Form.Item>
            </Col>
            <Col md="6" xs="12">
              {/* {isEdit ? (
                <>
                  <h5>Logo</h5>
                  <Image
                    width={100}
                    src={
                      hospitalData.hospitalLogo
                        ? `${configuration.API_URL}auth/assets/${hospitalData.hospitalLogo}`
                        : noLogo
                    }
                  />
                  {!hospitalData.hospitalLogo && (
                    <span className="color-grey font-weight-bold">
                      No logo available
                    </span>
                  )}
                </>
              ) : ( */}
              <Form.Item
                label="Provider Logo"
                name="hospitalLogo"
                valuePropName="fileList"
                getValueFromEvent={(e) => e?.fileList}
              >
                <Upload
                  listType="picture-card"
                  onPreview={handlePreview}
                  onChange={({ fileList }) => {
                    const normalizedFileList = fileList.map((file) => ({
                      ...file,
                      status: "done", // Set status to 'done' for proper rendering
                    }));
                    setFileList(normalizedFileList); // Update local state
                    form.setFieldsValue({ upload: normalizedFileList }); // Sync with Form stateu
                  }}
                  fileList={fileList}
                  maxCount={1}
                  // beforeUpload={() => false}

                  beforeUpload={(file) => {
                    const isAllowedType = [
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                    ].includes(file.type);
                    if (!isAllowedType) {
                      messageApi.error(
                        "You can only upload PNG, JPG, or JPEG files!"
                      );
                    }
                    return isAllowedType ? false : Upload.LIST_IGNORE;
                  }}
                >
                  <Icon
                    icon={
                      fileList.length === 0
                        ? "fluent:add-32-regular"
                        : "tabler:edit"
                    }
                    width="14"
                    height="14"
                    style={{ color: "#a7a7a7" }}
                  />{" "}
                  &ensp;{fileList.length === 0 ? "Add" : "Edit"}
                </Upload>
                {previewImage && (
                  <Image
                    title=""
                    wrapperStyle={{
                      display: "none",
                    }}
                    preview={{
                      visible: previewOpen,
                      onVisibleChange: (visible) => setPreviewOpen(visible),
                      afterOpenChange: (visible) =>
                        !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                  />
                )}
              </Form.Item>
              {/* )} */}
            </Col>
            {/* {!isEdit && ( */}
            <Col xs={12}>
              <Form.Item>
                <Button
                  className="uniteButton-lg py-3"
                  type="primary"
                  htmlType="submit"
                >
                  <Icon
                    icon="lets-icons:save-light"
                    width="20"
                    height="20"
                    style={{ color: "white" }}
                  />{" "}
                  {isEdit ? "Update" : "Save"}
                </Button>
              </Form.Item>
            </Col>
            {/* )} */}
          </Row>
        </Form>
      </>
    </>
  );
};

export default ViewHospitalProfile;
